import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import EventSchedule16 from '@carbon/icons-react/es/event--schedule/16';
import { DatePicker } from 'antd';
import styled from 'styled-components';
import { DATE_INPUT_DISPLAY_FORMAT } from 'api/models';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { useTranslation } from 'hooks/use-translation';
import { getBackgroundColor, NewInputBorder } from '../input/input';
import { DueDatePickerFooter } from './footer';
const NewUIRangePicker = styled(DatePicker.RangePicker)`
  background-color: ${getBackgroundColor(true)};
  ${NewInputBorder};
  padding: var(--spacing-02) var(--spacing-05);
  height: var(--height-base);
  &.ant-picker-disabled {
    opacity: 0.5;
  }
`;
export const DueDateRangePicker = ({ footerText, endDateTextRange, canChooseStartDate, disallowSingleDate, hideFooter, isTodayDisabled, isTomorrowDisabled, clearDates, modifyPickerType, pickToday, pickTomorrow, updateDateRange, hideModifyPicker, hideClearDate, onDone, disabledDate, dateRenderer, panelRender, ...rest })=>{
    const startDateText = useTranslation('start_date');
    const defaultText = useTranslation('due_date');
    const dueDateText = endDateTextRange !== null && endDateTextRange !== void 0 ? endDateTextRange : defaultText;
    const isNewDesignEnabled = useAntdRlUISwitcher();
    const RangePickerToUse = isNewDesignEnabled ? NewUIRangePicker : DatePicker.RangePicker;
    return /*#__PURE__*/ _jsx(RangePickerToUse, {
        ...rest,
        format: DATE_INPUT_DISPLAY_FORMAT,
        allowEmpty: [
            true,
            true
        ],
        bordered: false,
        open: true,
        placeholder: [
            startDateText,
            dueDateText
        ],
        tabIndex: -1,
        suffixIcon: /*#__PURE__*/ _jsx(EventSchedule16, {}),
        onChange: updateDateRange,
        disabledDate: disabledDate,
        dateRender: dateRenderer,
        panelRender: panelRender,
        renderExtraFooter: ()=>/*#__PURE__*/ _jsx(_Fragment, {
                children: !hideFooter ? /*#__PURE__*/ _jsx(DueDatePickerFooter, {
                    footerText: footerText,
                    canChooseStartDate: canChooseStartDate,
                    disallowSingleDate: disallowSingleDate,
                    hideModifyPicker: hideModifyPicker,
                    hideClearDate: hideClearDate,
                    type: "range",
                    onPickToday: pickToday,
                    onPickTomorrow: pickTomorrow,
                    onClear: clearDates,
                    modifyPickerType: modifyPickerType,
                    onDone: onDone,
                    isTodayDisabled: isTodayDisabled,
                    isTomorrowDisabled: isTomorrowDisabled
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            })
    });
};
